import Axios from 'Helpers/axios';

const updateNotificationStatus = async (params) => {
	try {
		const result = await Axios({
			method: 'POST',
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fcm/updateNotificationStatus`,
			headers: {
				authorization: params.authorization,
			},
			data: params.body,
		});

		return result;
	} catch (error) {
		throw new Error('Error Something');
	}
};

export default updateNotificationStatus;
